export default "__VITE_ASSET__34b9e91c__"